import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { SfaSalesLeadEntityLinkContainerModel } from "../../../../../../models/aggregates/sfa/salesLead/SfaSalesLeadEntityLinkContainer.model";
import { BaseApiTemplateService } from "../../shared/base-api-template-service.model";
import { Core2Config } from "../../shared/core2Config";

@Injectable({
    providedIn: 'root'
    })
    export class SfaSalesLeadEntityLinkService extends BaseApiTemplateService<SfaSalesLeadEntityLinkContainerModel> {

    readonly url = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.SFA_MODULE_PREFIX + 'lead-entity-links';

    constructor(http: HttpClient) {
        super();
        this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.SFA_MODULE_PREFIX + 'lead-entity-links';
        this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.SFA_MODULE_PREFIX + 'lead-entity-links';
        this.httpClient = http;
    }
    }